import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import Notifications from 'vue-notification'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(Notifications);

new Vue({
  render: h => h(App),
}).$mount('#app')
